import React, {Component} from 'react';
import {byPropKey} from "../utils";
import ChangeProfileInfoTab from "./changeprofileinfo/ChangeProfileInfoTab";
import ChangePasswordTab from "./changepassword/ChangePasswordTab";
import {BOOTSTRAP_MAX_XS} from "../../constants/bootstrapResponsive";
import MediaQuery from "react-responsive";

const TAB_EDIT_PROFILE = 'TAB_EDIT_PROFILE';
const TAB_CHANGE_PASSWORD = 'TAB_CHANGE_PASSWORD';

const INITIAL_STATE = {
    currentTab: TAB_EDIT_PROFILE
};

/**
 * A switcher component that encapsulates and
 * switches the tab view currently displayed
 * to the user on the account management page.
 */
class AccountTabSwitcher extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...INITIAL_STATE
        };
    }

    setEditProfileTabState = (event) => {
        this.setState(byPropKey('currentTab', TAB_EDIT_PROFILE));
    };

    setChangePasswordTab = (event) => {
        this.setState(byPropKey('currentTab', TAB_CHANGE_PASSWORD));
    };

    getTabToShow = (currentTab) => {
        switch(currentTab) {
            case TAB_CHANGE_PASSWORD:
                return <ChangePasswordTab/>;
            case TAB_EDIT_PROFILE:
                // fallthrough default case
            default:
                return <ChangeProfileInfoTab updateDisplayName={this.props.updateDisplayName}/>;
        }
    };

    render() {
        const tabToShow = this.getTabToShow(this.state.currentTab);
        const unselectedClass = "btn btn-outline-secondary btn-lg";
        const selectedClass = "btn btn-secondary btn-lg";

        return (
            <div className="text-center">
                <div className="btn-group" style={{margin: '0 auto', display: 'inline-block', width: 'inherit', textAlign: 'center'}} role="group">
                    <div
                        onClick={this.setEditProfileTabState}
                        className={this.state.currentTab === TAB_EDIT_PROFILE ? selectedClass : unselectedClass}
                    >
                        <i className="fas fa-user"/>
                        <MediaQuery minWidth={BOOTSTRAP_MAX_XS}>
                            <span>{' Edit Profile'}</span>
                        </MediaQuery>
                    </div>
                    <div
                        onClick={this.setChangePasswordTab}
                        className={this.state.currentTab === TAB_CHANGE_PASSWORD ? selectedClass : unselectedClass}
                    >
                        <i className="fas fa-unlock-alt"/>
                        <MediaQuery minWidth={BOOTSTRAP_MAX_XS}>
                            <span>{' Change Password'}</span>
                        </MediaQuery>
                    </div>
                </div>
                <ul>
                    <li style={{display: 'inline', paddingRight: '5px'}}>
                    </li>
                    <li style={{display: 'inline', paddingRight: '5px'}}>
                    </li>
                </ul>

                {tabToShow}
            </div>
        );
    }
}

export default AccountTabSwitcher;



// WEBPACK FOOTER //
// ./src/components/account/AccountTabSwitcher.jsx